<app-title-bar rootBreadCrumbs="['i18n.core.navigation.vendor-score-card', 'i18n.core.navigation.vendor-score-card-vendors']" 
titleText={{vendorScoreCardName}}></app-title-bar>
<div class="grid-additional-info">
  <b>{{'i18n.domain.vendor-score-card.vendor-score-card-vendors.total-points' | translate}}:</b> {{vendorScoreCardTotalPoints}}
</div>
<div class="control-section overflow-x">
  <ejs-grid #grid
            class="grid-with-toolbar"
            width='100%'
            rowHeight='38'
            [dataSource]='data'
            [allowSorting]='false'
            [filterSettings]='filterSettings'
            [allowFiltering]='false'
            [allowPaging]='false'
            [enableHover]='false'
            [allowSelection]='false'
            [pageSettings]='pageSettings'
            [editSettings]='customEditSettings'
            [searchSettings]="searchOptions"
            (actionBegin)="actionBegin($event)"
            (actionComplete)="actionComplete($event)"
            (rowDataBound)="onRowDataBound($event)"
            (dataBound)="onDataBound($event)"
            >
    <e-columns>
      <e-column field={{columnRowType}}
                [visible]='true'
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-administration.row' | translate}}"
                isPrimaryKey="true">
                <ng-template #template let-data>
                  <div [innerHTML]="getRowTypeHtml(data.rowType)"></div>
                </ng-template>
              </e-column>
      <e-column field={{columnFacts}} width="160"
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-survey.facts' | translate}}"
                clipMode='EllipsisWithTooltip'>
                <ng-template #template let-data>
                  <div>{{displayData(data.facts, data.rowType, columnFacts)}}</div>
                </ng-template>
      </e-column>
      <e-column field={{columnPoints}} width="160"
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-survey.points' | translate}}"
                clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column field={{columnWeightedPoints}} width="160"
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-survey.weighted-points' | translate}}"
                clipMode='EllipsisWithTooltip'
                format="N2">
      </e-column>
      <e-column field={{columnTotalPointsCategory}} width="160"
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-survey.total-points-cat' | translate}}"
                clipMode='EllipsisWithTooltip'
                format="N2">
      </e-column>
    </e-columns>
  </ejs-grid>
</div>